export default "__VITE_ASSET__09c89fb5__"